import { StepIdentifier } from "api/risk";
import { SubscriptionProcessAction } from "./actions/types";
import { SubscriptionProcessState } from "./types";

export const initialState: SubscriptionProcessState = {
  branchCode: null,
  riskId: '',
  folderIdentifier: '',
  subscriptionState: {
    currentStepIdentifier: StepIdentifier.Registration,
    highestAccessibleStep: StepIdentifier.Registration,
    isProcessCompleted: false,
    steps: []
  },
  riskData: null,
  contractualizationData: null,
  unreadHistoryCount: 0,
  currentQuoteId: null,
  currentBorrowerProjectId: null,
  isLoading: true,
  error: null
}

export const subscriptionProcessReducer = (
  state: SubscriptionProcessState,
  action: SubscriptionProcessAction): SubscriptionProcessState => {
  switch (action.type) {
    case 'INIT_SUBSCRIPTION_DATA':
      return {
        ...state,
        branchCode: action.payload.branchCode,
        riskId: action.payload.riskId,
        folderIdentifier: action.payload.folderIdentifier,
        subscriptionState: action.payload.subscriptionState,
        riskData: action.payload.riskData ?? null,
        contractualizationData: action.payload.contractualizationData ?? null,
        unreadHistoryCount: action.payload.unreadHistoryCount ?? 0
      }
    case 'SET_CURRENT_BORROWER_PROJECT_ID':
      return { ...state, currentBorrowerProjectId: action.payload }
    case 'SET_CURRENT_QUOTE_ID':
      return { ...state, currentQuoteId: action.payload }
    case 'SET_UNREAD_HISTORY_COUNT':
      return { ...state, unreadHistoryCount: action.payload }
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload }
    case 'SET_ERROR':
      return { ...state, error: action.payload, isLoading: false }
    case 'RESET':
      return initialState
    default:
      return state
  }
}
